import * as React from "react";

import * as LF from "leaflet";
import 'leaflet/dist/leaflet.css'
import 'leaflet.fullscreen'
import 'leaflet.fullscreen/Control.FullScreen.css'
import 'leaflet.utm'
import UgSpatial from "../../../ug/ug_spatial";
import Basemap from "../../../ug/basemap";
import  api from '../../../service/api'
import GeoServer from "../../../service/geoserser";
import Wait from "../../wait";
import ReadService from "../../../service/read";

export default class  ParcelSpatialUnit extends React.Component{

    constructor(props) {
        super(props);

        this.state = {
            rc_codes:[],
            search:'',
            current_tab:0,
            totalPages:1,
            currentPage:1,
            layers:[],
            coordinates:[]
        }

        this.handleChange = this.handleChange.bind(this)
        this.searchUser = this.searchUser.bind(this)
        this.loadLayers = this.loadLayers.bind(this)
        this.loadMap = this.loadMap.bind(this)
    }

    handleChange=(e)=>{ this.setState({[e.target.name]:e.target.value}) }



    componentDidMount() {
        this.loadMap()
        this.loadLayers()
    }

    searchUser(){

    }



    render() {
        const fontFamily = 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif';
        const card = {
            background: '#fff',
            borderRadius: 12,
            boxShadow: '0 4px 12px rgba(57,93,154,0.10)',
            padding: 0,
            margin: '16px auto',
            border: '1px solid #e0e7ef',
            maxWidth: 1200,
            fontFamily,
            overflow: 'hidden'
        };
        const header = {
            background: 'linear-gradient(90deg, #395d9a 0%, #2bbbad 100%)',
            color: '#fff',
            fontSize: 18,
            fontWeight: 700,
            padding: '16px 24px',
            borderTopLeftRadius: 12,
            borderTopRightRadius: 12,
            letterSpacing: 1,
        };
        const grid = {
            display: 'grid',
            gridTemplateColumns: '2fr 1fr',
            gap: 0,
            minHeight: '60vh',
        };
        const gridMobile = {
            display: 'block',
        };
        const mapBox = {
            width: '100%',
            minHeight: '350px',
            height: '60vh',
            background: '#efefef',
            borderRight: '1px solid #e0e7ef',
        };
        const coordinatesBox = {
            width: '100%',
            height: '60vh',
            overflowY: 'auto',
            background: '#f8f9fa',
            padding: '24px',
            boxSizing: 'border-box',
        };
        const coordinatesHeader = {
            fontSize: 16,
            fontWeight: 700,
            color: '#395d9a',
            marginBottom: 16,
            paddingBottom: 8,
            borderBottom: '2px solid #e0e7ef',
            fontFamily
        };
        const coordinateItem = {
            background: '#fff',
            borderRadius: 8,
            padding: 12,
            marginBottom: 8,
            border: '1px solid #e0e7ef',
            boxShadow: '0 2px 4px rgba(57,93,154,0.05)',
            transition: 'all 0.2s ease'
        };
        const coordinateNumber = {
            fontSize: 14,
            fontWeight: 700,
            color: '#395d9a',
            marginBottom: 4,
            fontFamily
        };
        const coordinateValue = {
            fontSize: 13,
            color: '#666',
            fontFamily: 'monospace',
            background: '#f8f9fa',
            padding: '4px 8px',
            borderRadius: 4,
            border: '1px solid #e0e7ef'
        };
        const coordinateLabel = {
            fontSize: 11,
            color: '#999',
            textTransform: 'uppercase',
            fontWeight: 600,
            marginBottom: 2,
            fontFamily
        };
        const emptyState = {
            textAlign: 'center',
            color: '#666',
            fontSize: 14,
            padding: '40px 20px',
            fontFamily
        };
        const isMobile = typeof window !== 'undefined' && window.innerWidth < 900;
        return (
            <div style={{padding: '0 0 24px 0', background: '#f6f8fa', minHeight: '66vh'}}>
                <div style={card}>
                    <div style={isMobile ? gridMobile : grid}>
                        <div style={mapBox}>
                            <div style={{width: '100%', height: '100%'}} id={'ramani'}></div>
                        </div>
                        <div style={coordinatesBox}>
                            <div style={coordinatesHeader}>
                                <span className="fa fa-map-marker" style={{marginRight: 8}}/>
                                Coordinates ({this.state.coordinates.length} points)
                            </div>
                            {this.state.coordinates.length > 0 ? (
                                this.state.coordinates.map((coordinate, i) => (
                                    <div key={i} style={coordinateItem}>
                                        <div style={coordinateNumber}>
                                            Point {i + 1}
                                        </div>
                                        <div style={{display: 'flex', flexDirection: 'column', gap: 4}}>
                                            <div>
                                                <div style={coordinateLabel}>X Coordinate</div>
                                                <div style={coordinateValue}>{coordinate[0]}</div>
                                            </div>
                                            <div>
                                                <div style={coordinateLabel}>Y Coordinate</div>
                                                <div style={coordinateValue}>{coordinate[1]}</div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div style={emptyState}>
                                    <span className="fa fa-map" style={{fontSize: 24, marginBottom: 8, display: 'block', color: '#ccc'}}/>
                                    No coordinates available
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    loadMap() {
        UgSpatial.clear()

        try{
            Wait.show('Loading Spatial...')
            ReadService.getParcelSpatial(this.props.parcel.id).then(r => {
                Wait.dismiss()
                try{
                    console.log('Raw coordinates data:', r.data.features[0].geometry.coordinates)
                    this.setState({
                        coordinates:r.data.features[0].geometry.coordinates
                    })
                    let parcel = LF.geoJSON(r.data)

                    let ly_labels = new LF.FeatureGroup(),
                        ly_beacons = new LF.FeatureGroup(),
                        ly_plots = new LF.FeatureGroup()
                    let sat = Basemap.googleSat(),
                        hybrid = Basemap.googleHybrid(),
                        gray = Basemap.backWhite(),
                        blank = LF.tileLayer('')

                    let map = UgSpatial.map==null?LF.map('map', {
                        layers: [sat,ly_plots, parcel],
                        attributionControl: false,
                        fullscreenControl: true,
                        fullscreenControlOptions: {
                            position: 'topleft'
                        },
                        maxZoom:10000
                    }).setView([-6.085936, 35.711995], 6):UgSpatial.map


                    let baseLayers = {
                        'Gray':gray,
                        "<span style='color: gray'>Blank</span>": blank,
                        "Satellite": sat,
                        "Hybrid": hybrid
                    }

                    let overlays = {
                        'Village Boundary':ly_plots,
                        'Hamlet Boundary':ly_labels,
                        'Land Use':ly_beacons,
                        'Conceptual Diagrams':ly_beacons,
                        'Parcel':parcel

                    }

                    map.fitBounds(parcel.getBounds())
                    UgSpatial.layers = LF.control.layers(baseLayers,overlays, {position: 'bottomleft'}).addTo(map)
                }catch (e) {
                    console.log(e)
                }


            })
        }catch (e) {
            console.log(e)
        }





    }

    loadLayers() {

    }
}